import { InternalEvent, StorageEvent } from '../event';
import channel from '../utils/channel';
import TransactionContext from './transaction-context';
var TransactionManager = /** @class */ (function () {
    function TransactionManager(eventBus, comparer) {
        var _this = this;
        this.handleFetalError = function (err) {
            _this.channelDB.close(err, true);
            _this.channelModel.close(err);
            _this.channelLazyMigration.close(err);
        };
        this.eventBus = eventBus;
        this.channelDB = channel();
        this.channelModel = channel(function (e) { return e.schema.name; });
        this.channelLazyMigration = channel(function (name) { return name; });
        this.comparer = comparer;
        this.eventBus.on(StorageEvent.Fetal, this.handleFetalError);
        this.eventBus.on(StorageEvent.Ready, this.channelDB.send);
        this.eventBus.on(StorageEvent.RegisterModel, this.channelModel.send);
        this.eventBus.on(InternalEvent.ModelLazyMigrationEnd, this.channelLazyMigration.send);
    }
    TransactionManager.prototype.spawnAutoCommitContext = function () {
        return TransactionContext.fromTransactionManager(this, false);
    };
    TransactionManager.prototype.spawnKeepAliveContext = function () {
        return TransactionContext.fromTransactionManager(this, true);
    };
    TransactionManager.prototype.openChannels = function () {
        this.channelDB.open();
        this.channelModel.open();
        this.channelLazyMigration.open();
    };
    return TransactionManager;
}());
export default TransactionManager;
//# sourceMappingURL=transaction-manager.js.map